import css from 'styled-jsx/css';

const styles = css.global`#mao-na-roda-comparativo {
  background: #fff;
  padding: 40px 0 16px;
}

#mao-na-roda-comparativo .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
}

#mao-na-roda-comparativo .comparativo-titulo {
  color: #444;
  font-family: 'SantanderHeadline';
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-align: left;
}

#mao-na-roda-comparativo .comparativo-tabela {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #CCC;
  border-radius: 8px;
  padding: 24px 8px;
  max-width: 930px;
}

#mao-na-roda-comparativo .comparativo-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #222;
  font-family: 'SantanderText';
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
}

#mao-na-roda-comparativo .comparativo-tag img {
  width: 24px;
  height: 24px;
}

#mao-na-roda-comparativo .tabela-header {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e5e5;
}

#mao-na-roda-comparativo .tabela-col {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #222;
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
}

#mao-na-roda-comparativo .tabela-col img {
  width: 20px;
  height: 20px;
}

#mao-na-roda-comparativo .tabela-col:nth-child(2) {
  border-left: 1px solid #e5e5e5;
}

#mao-na-roda-comparativo .tabela-titulo {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  background: #deedf2;
  border-radius: 4px;
  padding: 8px;
}

#mao-na-roda-comparativo .tabela-titulo.tabela-titulo-full {
  grid-template-columns: 1fr;
  text-align: center;
}

#mao-na-roda-comparativo .tabela-titulo-col {
  display: flex;
  flex-direction: column;
  text-align: center;
}

#mao-na-roda-comparativo .tabela-titulo-col:nth-child(2) {
  border-left: 1px solid #e5e5e5;
  padding-left: 16px;
}

#mao-na-roda-comparativo .tabela-titulo strong,
#mao-na-roda-comparativo .tabela-titulo-col strong {
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

#mao-na-roda-comparativo .tabela-titulo span,
#mao-na-roda-comparativo .tabela-titulo-col span {
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
}

#mao-na-roda-comparativo .tabela-uso {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

#mao-na-roda-comparativo .tabela-uso-col {
  color: #222;
  font-family: 'SantanderMicroText';
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
  padding: 0 8px;
}

#mao-na-roda-comparativo .tabela-uso-col:nth-child(2) {
  border-left: 1px solid #e5e5e5;
}

@media (min-width: 992px) {
  #mao-na-roda-comparativo {
    padding: 40px 0 27px;
  }

  #mao-na-roda-comparativo .comparativo-tabela {
    padding: 24px;
  }
}
`;

export default styles;